import { isHealthFeature } from "./HealthReport.types";
import { formatLeafCount } from "./healthTree";
import mockHealthReport from "./mockHealthReport";
const SYNTHETIC_ROOT_ID = "cluster_health";
const SYNTHETIC_ROOT_TITLE = "Cluster Health";
const toTreeData = (node) => ({
  value: node.id,
  label: node.title,
  nodeProps: {
    status: node.status,
    countSummary: formatLeafCount(node)
  },
  children: isHealthFeature(node) ? node.children.map(toTreeData) : void 0
});
const buildLookup = (root) => {
  const lookup = {};
  const visit = (node) => {
    lookup[node.id] = node;
    if (isHealthFeature(node)) {
      node.children.forEach(visit);
    }
  };
  visit(root);
  return lookup;
};
const buildPaths = (root) => {
  const paths = {};
  const visit = (node, parentPath = []) => {
    const path = [...parentPath, node.title];
    paths[node.id] = path;
    if (isHealthFeature(node)) {
      node.children.forEach((child) => visit(child, path));
    }
  };
  visit(root);
  return paths;
};
const buildHealthModuleState = (report) => {
  const root = {
    id: SYNTHETIC_ROOT_ID,
    title: SYNTHETIC_ROOT_TITLE,
    status: report.overall_status,
    children: report.features
  };
  return {
    root,
    treeData: [toTreeData(root)],
    lookup: buildLookup(root),
    paths: buildPaths(root),
    initialExpandedState: { [root.id]: true }
  };
};
const HEALTH_MODULE_STATE = buildHealthModuleState(mockHealthReport);
const useHealthModule = () => HEALTH_MODULE_STATE;
export const useHealthSummary = () => ({
  overallStatus: mockHealthReport.overall_status
});
export default useHealthModule;
